import { render, staticRenderFns } from "./EditPlaylist.vue?vue&type=template&id=20b174d2"
import script from "./EditPlaylist.vue?vue&type=script&lang=js"
export * from "./EditPlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports